import { useCallback, useEffect, useState } from 'react';
import { ClientFormStep } from 'checkout/components/Client/types';

const getInitialState = (isAuth: boolean) =>
  isAuth ? ClientFormStep.CLIENT_INFO : ClientFormStep.AUTH;

export const useClientFormStepState = (isAuth: boolean) => {
  const [clientFormStep, setClientFormStep] = useState<ClientFormStep>(
    getInitialState(isAuth),
  );

  // useEffect нужен для обновления локального стейта после логина/логаута
  useEffect(() => {
    setClientFormStep(getInitialState(isAuth));
  }, [isAuth]);

  const openConfirmationPhone = useCallback(() => {
    setClientFormStep(ClientFormStep.PHONE_CONFIRMATION);
  }, [setClientFormStep]);

  const openMailConfirmation = useCallback(() => {
    setClientFormStep(ClientFormStep.MAIL_CONFIRMATION);
  }, [setClientFormStep]);

  const openClientInfo = useCallback(() => {
    setClientFormStep(ClientFormStep.CLIENT_INFO);
  }, [setClientFormStep]);

  const openSendSmsCodeAgainForm = useCallback(() => {
    setClientFormStep(ClientFormStep.SEND_SMS_CODE_AGAIN_FORM);
  }, [setClientFormStep]);

  const openLoginForm = useCallback(() => {
    setClientFormStep(ClientFormStep.AUTH);
  }, [setClientFormStep]);

  return {
    clientFormStep,
    setClientFormStep,
    openConfirmationPhone,
    openMailConfirmation,
    openClientInfo,
    openSendSmsCodeAgainForm,
    openLoginForm,
  };
};
